(ns ncr.etc.reload
  (:require
   [uix.core.alpha :as uix]))

(defonce ^:private registry
  (atom {}))

(defonce ^:private unloading
  (atom false))

(defn- ^:dev/before-load reloading! []
  (reset! unloading true))

(defn reloaded! []
  (.requestAnimationFrame js/window
    #(reset! unloading false)))

(defn use-reload! [deps state]
  (uix/effect!
    (fn []
      (when-let [v (@registry deps)]
        (reset! state v)
        (swap! registry dissoc deps))
      (fn []
        (if @unloading
          (swap! registry assoc deps @state)
          (swap! registry dissoc deps))))
    [deps])
  state)